import Backbone from "backbone";

let isNarrationPopupAcknowledged = false;

Backbone.Events.listenTo(Backbone.Events, "scorm:hide-slide-view", () => {
  // @ts-ignore
  const { Sound } = window.Application.actions();
  Sound.stopAll();
});

Backbone.Events.listenTo(
  Backbone.Events,
  "scorm:narration-started",
  (payload) => {
    if (!isNarrationPopupAcknowledged) {
      const popup = document.querySelector("#play-audio-popup");
      if (!popup) return;

      document
        .querySelector("#play-audio-popup .btn-yes")
        .addEventListener("click", () => {
          isNarrationPopupAcknowledged = true;
          popup.classList.remove("active");

          Backbone.Events.trigger("event:narration-started", payload);
        });

      popup.classList.add("active");
      return;
    }

    const {
      audio_file: audioFile,
      progress_on_completion: progressOnCompletion,
    } = payload || {};

    // @ts-ignore
    const { Sound } = window.Application.actions();

    Sound.stopAll();

    if (audioFile) {
      Sound.play(audioFile, {
        onProgress: (progress) => {
          Backbone.Events.trigger("subscribe:narration-progressing", {
            progress,
          });
        },
        onComplete: () => {
          Backbone.Events.trigger("event:narration-completed", {
            progress_on_completion: progressOnCompletion,
          });
        },
      });
    }
  }
);

Backbone.Events.listenTo(
  Backbone.Events,
  "scorm:current-audio-src-changed",
  (payload) => {
    const { currentSrc } = payload || {};

    // @ts-ignore
    const { Sound } = window.Application.actions();

    Sound.stopAll();
    if (currentSrc) {
      Sound.play(currentSrc, {
        onProgress: (progress) => {
          Backbone.Events.trigger("subscribe:narration-progressing", {
            progress,
          });
        },
        onComplete: () => {
          Backbone.Events.trigger("event:narration-completed", {});
        },
      });
    }
  }
);
